import { useAtomValue } from 'jotai';

import { useAppConfig } from '@common/app-config';
import {
  hideSizeTabTooltipAtom,
  SIZE_TAB_TOOLTIP_KEY,
  stickyTabRefAtom,
  TabType,
  useActiveTabTypeAtom,
  useCatalogProductIdParams,
  useGetPdpIntegratedData,
  usePdpBaseInfo,
} from '@domains/pdp-common';

export const useProductSizeInfoIconService = () => {
  const { catalog_product_id } = useCatalogProductIdParams();
  const [, setActiveTabType] = useActiveTabTypeAtom();

  const {
    product,
    flags: { is_size_tab_visible },
  } = usePdpBaseInfo({ catalog_product_id });

  const { isZigzagApp } = useAppConfig();
  const stickyTabRef = useAtomValue(stickyTabRefAtom);
  const hideSizeTabTooltip = useAtomValue(hideSizeTabTooltipAtom);

  const { pdp_size_info } = useGetPdpIntegratedData({ catalog_product_id: product.id });

  const isVisible = is_size_tab_visible || Boolean(pdp_size_info?.item_list.length);

  const handleClick = () => {
    setActiveTabType(TabType.SIZE_INFO);

    // ATF 사이즈 진입점을 통한 진입 시 툴팁 미노출 처리
    localStorage.setItem(SIZE_TAB_TOOLTIP_KEY, 'true');
    hideSizeTabTooltip?.();

    if (stickyTabRef.current) {
      const headerHeight = isZigzagApp ? 0 : 44;
      const rect = stickyTabRef.current.getBoundingClientRect();
      const targetScrollY = window.scrollY + rect.top - headerHeight;

      window.scrollTo({
        top: targetScrollY,
        behavior: 'smooth',
      });
    }
  };

  return {
    isVisible,
    onClick: handleClick,
  };
};
